import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";




@Component(
  {
      selector: 'colaboradorhijo',
      templateUrl: './colaboradorhijo.component.html',
      styleUrls: ['./colaboradorhijo.component.scss']
  })

  export class ColaboradorHijoComponent implements AfterViewInit {
    dataTable!: Array<any>;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string;
    transformedDataSource: any[] = [];
    columns: any[] = [];

    SelNivel: any[] = [];
    SelEstatusAlumno: any[] = [];
    SelEstatusColaborador: any[] = [];
    SelEstatusAlumnoPorCiclo: any[] = [];

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.uriApi = "reporte/colaborador/colaboradorhijo";
        this.GenerarFiltros();
    }

    ngAfterViewInit() {
      this.SetNivelFiltro();
      this.selAlumnoEstatusFiltro();
      this.setEstatusColaboradorFiltro();
      this.setEstatusAlumnoporCicloFiltro();
    }

    GenerarFiltros() {
      let filtrosDisplay: Array<FiltroModel> = [];

      filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.Input,
                  Titulo: 'Nombre del alumno',
                  Obligatorio: false,
                  MensajeError: "",
                  Propiedad: 'nombre'
              })
      );
      filtrosDisplay.push(
          new FiltroModel(
              {
                TipoFiltro: TipoFiltroEnum.Input,
                Titulo: 'Ap. Paterno del alumno',
                Obligatorio: false,
                MensajeError: "",
                Propiedad: 'apellidopaterno'
              })
      );
      filtrosDisplay.push(
        new FiltroModel(
            {
              TipoFiltro: TipoFiltroEnum.Input,
              Titulo: 'Ap. Materno del alumno',
              Obligatorio: false,
              MensajeError: "",
              Propiedad: 'apellidomaterno'
            })
      );
      filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Nivel del alumno',
                  DisplayValor: 'nombre',
                  ValorName: 'nivelid',
                  Opciones: this.SelNivel,
                  Propiedad: 'nivelid',
                  Obligatorio: false,
                  Buscar: false,
              })
      );
      filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Estatus alumno',
                  DisplayValor: 'nombre',
                  ValorName: 'alumnoestatusid',
                  Opciones: this.SelEstatusAlumno,
                  Propiedad: 'alumnoestatusid',
                  Obligatorio: false,
                  Buscar: false,
              })
      );
      filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Estatus ciclo alumno',
                  DisplayValor: 'nombre',
                  ValorName: 'estatusalumnoporcicloid',
                  Opciones: this.SelEstatusAlumnoPorCiclo,
                  Propiedad: "estatusalumnoporcicloid",
                  Obligatorio: false,
                  Buscar: false
              })
      );
      filtrosDisplay.push(
        new FiltroModel(
            {
              TipoFiltro: TipoFiltroEnum.Input,
              Titulo: 'Clave familiar',
              Obligatorio: false,
              MensajeError: "",
              Propiedad: 'clavefamiliar',
              Mask: this.sistemaService.numeroEnteroMask
            })
      );
      filtrosDisplay.push(
        new FiltroModel(
            {
              TipoFiltro: TipoFiltroEnum.Input,
              Titulo: 'No. Nómina colaborador',
              Obligatorio: false,
              MensajeError: "",
              Propiedad: 'nomina',
              Mask: this.sistemaService.numeroEnteroMask
            })
      );
      filtrosDisplay.push(
        new FiltroModel(
            {
              TipoFiltro: TipoFiltroEnum.DropDown,
              Titulo: 'Estatus colaborador',
              DisplayValor: 'nombre',
              ValorName: 'estatuscolaboradorid',
              Opciones: this.SelEstatusColaborador,
              Propiedad: "estatuscolaboradorid",
              Obligatorio: false,
              Buscar: false
            })
      );

      this.filtrosDisplay = filtrosDisplay;
    }

    SetNivelFiltro() {
      this.appService.Get("catalogo/nivel").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelNivel = res.data;
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'nivelid');
              if (filtro) {
                  filtro.Opciones = this.SelNivel;
              }
          }
      });
    }


    selAlumnoEstatusFiltro() {
      this.appService.Get("catalogo/alumnoestatus").then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
          this.SelEstatusAlumno = res.data
          let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'alumnoestatusid');
          if (filtro) {
              filtro.Opciones = this.SelEstatusAlumno;
          }
        }
      });
    }

    setEstatusColaboradorFiltro() {
      this.appService.Get("catalogo/estatuscolaborador").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelEstatusColaborador = res.data
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'estatuscolaboradorid');
              if (filtro) {
                  filtro.Opciones = this.SelEstatusColaborador;
              }
          }
      });
    }
    setEstatusAlumnoporCicloFiltro() {
      this.appService.Get("catalogo/estatuscicloalumno").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelEstatusAlumnoPorCiclo = res.data
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'estatusalumnoporcicloid');
              if (filtro) {
                  filtro.Opciones = this.SelEstatusAlumnoPorCiclo;
              }
          }
      });
    }

    SetDatos(data:any){
      this.dataTable = data;

      this.transformedDataSource = this.dataTable.map(item => {
        const transformedItem: any = { primernombre: item.primernombre, apellidopaterno: item.apellidopaterno, apellidomaterno: item.apellidomaterno, clavefamiliar: item.clave, matricula:item.matricula,
          nivel: item.nivel, grado: item.grado, grupo:item.grupo, estatusalumno: item.estatus, estatusalumnociclo: item.estatusalumnocicloid
         };
        item.colaboradores.forEach((detail:any, index:any) => {
          transformedItem[`nombrecolaborador${index + 1}`] = detail.colaborador;
          transformedItem[`email${index + 1}`] = detail.emailinstitucional;
          transformedItem[`telefono${index + 1}`] = detail.telefonocelular;
          transformedItem[`nomina${index + 1}`] = detail.nomina;
          transformedItem[`nivel${index + 1}`] = detail.nivel;
          transformedItem[`puesto${index + 1}`] = detail.puesto;
          transformedItem[`estatuscolaborador${index + 1}`] = detail.estatuscolaborador;
        });

        item.padres.forEach((data:any, index:any) => {
          transformedItem[`padremadre${index + 1}`] = data.nombre+" "+data.apellidopaterno+" "+data.apellidomaterno;
          transformedItem[`correo${index + 1}`] = data.correo;
          transformedItem[`celular${index + 1}`] = data.celular;
        });
        return transformedItem;
      });

      // Crear columnas dinámicas

      this.columns = [
        { dataField: 'matricula', caption: 'Matricula' },
        { dataField: 'primernombre', caption: 'Nombre' },
        { dataField: 'apellidopaterno', caption: 'Ap Paterno' },
        { dataField: 'apellidomaterno', caption: 'AP Materno' },
        { dataField: 'clavefamiliar', caption: 'Clave Fam.' },
        { dataField: 'grado', caption: 'Grado' },
        { dataField: 'grupo', caption: 'Grupo' },
        { dataField: 'nivel', caption: 'Nivel' },
        { dataField: 'estatusalumno', caption: 'Estatus' },
        { dataField: 'estatusalumnociclo', caption: 'Estatus ciclo' },
        ...Array.from({ length: Math.max(...this.dataTable.map(item => item.padres.length)) }, (_, index) => {
          return [
            { dataField: `padremadre${index + 1}`, caption: `Padre/Madre ${index + 1}`, width: 200 },
            { dataField: `correo${index + 1}`, caption: `Correo ${index + 1}` },
            { dataField: `celular${index + 1}`, caption: `Celular ${index + 1}` },
          ];
        }).reduce((acc, val) => acc.concat(val), []),
        ...Array.from({ length: Math.max(...this.dataTable.map(item => item.colaboradores.length)) }, (_, index) => {
          return [
            { dataField: `nombrecolaborador${index + 1}`, caption: `Colaborador (${index + 1})`, width: 200 },
            { dataField: `email${index + 1}`, caption: `Correo (${index + 1})` },
            { dataField: `telefono${index + 1}`, caption: `Telefono (${index + 1})` },
            { dataField: `nomina${index + 1}`, caption: `Nomina (${index + 1})` },
            { dataField: `nivel${index + 1}`, caption: `Nivel (${index + 1})` },
            { dataField: `puesto${index + 1}`, caption: `Puesto (${index + 1})`, width: 300 },
            { dataField: `estatuscolaborador${index + 1}`, caption: `Estatus colaborador (${index + 1})` },
          ];
        }).reduce((acc, val) => acc.concat(val), [])
      ];
    }

  }
